import { SaveManager, SaveData } from './SaveManager';
import { DiscordRichPresenceManager } from './DiscordRichPresenceManager';

export class GameManager {
  private static instance: GameManager | null = null;

  public saveData: SaveData;
  public playTimeSeconds = 0;
  public isPaused = false;
  public isGameOver = false;
  public isLevelComplete = false;

  private timerInterval: number | null = null;

  private constructor() {
    this.saveData = SaveManager.loadSave();
    this.playTimeSeconds = this.saveData.playTimeSeconds || 0;
  }

  public static getInstance(): GameManager {
    if (!this.instance) {
      this.instance = new GameManager();
    }
    return this.instance;
  }

  public startTimer(): void {
    if (this.timerInterval !== null) return;
    this.timerInterval = window.setInterval(() => {
      if (!this.isPaused && !this.isLevelComplete) {
        this.playTimeSeconds++;
      }
    }, 1000);
  }

  public stopTimer(): void {
    if (this.timerInterval !== null) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  public completeLevel(coins: number, gems: number): void {
    this.isLevelComplete = true;
    this.stopTimer();

    SaveManager.saveProgress({
      coins,
      gems,
      playTimeSeconds: this.playTimeSeconds,
      levelCompleted: true,
    });

    DiscordRichPresenceManager.updatePresence('Level Completed!', `Finished with ${coins} Coins & ${gems} Gems!`);
  }

  public resetSession(): void {
    this.playTimeSeconds = 0;
    this.isPaused = false;
    this.isGameOver = false;
    this.isLevelComplete = false;
    SaveManager.resetSave();
    this.saveData = SaveManager.getInitialSave();
  }
}
